import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import backgroundImage from "../../assets/images/background.png";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    darkSection: {
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
    },
    lightSection: {
      backgroundColor: "#fff",
    },
    straightContainer: {
      display: "flex !important",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-evenly",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    reversedContainer: {
      display: "flex !important",
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-evenly",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    textBox: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      textAlign: "left",
      width: "25vw",
      marginBottom: "5vh",
      [theme.breakpoints.down("sm")]: {
        width: "75vw",
        marginBottom: "1vh",
        paddingTop: "3vh",
      },
    },
    lightText: {
      color: "#fff",
    },
    darkText: {
      color: "#4f195c",
    },
    imageCut: {
      width: "auto",
      height: "40vh",
      maxHeight: "23rem",
      margin: "10vw 10vw 0 0",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "75vw",
        height: "25vw",
        margin: "2vh",
        marginBottom: 0,
      },
      [theme.breakpoints.down("xs")]: {
        height: "auto",
      },
    },
    imageFull: {
      width: "auto",
      height: "40vh",
      maxHeight: "20rem",
      margin: "10vw",
      borderRadius: 25,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "75vw",
        height: "25vw",
        margin: "2vh",
        marginBottom: "3vh",
      },
      [theme.breakpoints.down("xs")]: {
        height: "auto",
      },
    },
    imageLeft: {
      marginLeft: 0,
    },
    imageRight: {
      marginRight: 0,
    },
  }),
);

const useHeroSection = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useHeroSection as default };
